import { render } from "./FullScreenModal.vue?vue&type=template&id=ca7f6bde&scoped=true"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"

import "./FullScreenModal.vue?vue&type=style&index=0&id=ca7f6bde&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7f6bde"]])

export default __exports__